// Detect if theme is set
let theme =  getCookie('theme');
if(theme == 'light') {
  toggleTheme();
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

window.onscroll = function () {
  var navigation = document.getElementById("navigation");
  if (window.scrollY === 0) {
    navigation.classList.remove("scroll-nav");
  } else {
    navigation.classList.add("scroll-nav");
  }
};

const cursor = new MouseFollower({
  // container: '.mf-container',
  speed: 0.5,
});

function toggleTheme() {
  var html = document.getElementsByTagName("html")[0];
  html.classList.toggle("light");

  var themeToggle = document.getElementById("theme_toggle");
  themeToggle.classList.toggle("light");

  if(html.classList.contains('light')) {
    document.cookie = "theme=light";
    // particlesJS.load('particles-js', '/assets/js/particlesjs-dark-config.json', function() {
    //   console.log('callback - particles.js config loaded');
    // });
  } else {
    document.cookie = "theme=dark";
    // particlesJS.load('particles-js', '/assets/js/particlesjs-light-config.json', function() {
    //   console.log('callback - particles.js config loaded');
    // });
  }
}
var themeToggle = document.getElementById("theme_toggle");
themeToggle.addEventListener('click', function() {
    toggleTheme();
});

// function toggleSnow() {
// var snowCanvas = document.getElementById("particles-js");
//   snowCanvas.classList.toggle("hidden");
// }
// var snowToggle = document.getElementById("snow_toggle");
// snowToggle.addEventListener('click', function() {
//   toggleSnow();
// });

function toggleNav() {
    var navigation = document.getElementById('navigation');
    navigation.classList.toggle('open');

    var html = document.getElementsByTagName('html')[0];
    if(html.style.overflowY == 'visible') {
        html.style.overflowY = 'hidden';
    } else {
        html.style.overflowY = 'visible';
    }
}
var hamburger = document.getElementById('hamburger');
hamburger.addEventListener('click', function() {
    toggleNav();
});

function toggleNewsletterModal() {
  var newsletterModal = document.getElementById('newsletter_signup');
  newsletterModal.classList.toggle('open');
}
var newsletterModalToggle = document.getElementById('newsletter_modal_trigger');
newsletterModalToggle.addEventListener('click', function() {
  toggleNewsletterModal();
});
var newsletterModalClose = document.querySelector('#newsletter_signup .close');
newsletterModalClose.addEventListener('click', function() {
  toggleNewsletterModal();
});

window.playVideo = function (videoID, el) {
  el.classList.toggle('hide');
  let video = document.getElementById('video_' + videoID);
  if (video.paused) {
      video.play();
      video.setAttribute('loop', true);
  } else {
      video.pause();
  }
}